import { Flex, Text } from '@mantine/core';
import { IconFileText } from '@tabler/icons-react';
import * as React from 'react';
import { Link, useParams } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';
import type { DocumentListItem } from '@/entities/DocumentList';
import type { EventEntity } from '@/entities/OrganizationEvent';

import DocumentLinksList from '../DocumentLinksList';

import s from './Slide.module.scss';

type SlideProps = {
  event: EventEntity;
  dateInfo: { formattedDate: string; remainingLabel: string };
  latestDocuments?: DocumentListItem[];
  /** При true показываем только latestDocuments, не event.documents (режим «последние 10», agenda выключена). */
  forceLatestDocuments?: boolean;
};

const Slide = React.forwardRef<HTMLDivElement, SlideProps>((props, ref) => {
  const { id: organizationId } = useParams();
  const title = `До события «${props.event.title}» ${props.dateInfo.remainingLabel}${props.dateInfo.formattedDate ? ` (${props.dateInfo.formattedDate})` : ''}`;
  const useAgendaDocuments = !props.forceLatestDocuments && props.event.documents.length > 0;
  const showLatestDocuments = props.latestDocuments !== undefined;

  return (
    <div className={s.root} ref={ref}>
      <Flex align="center" justify="center" gap="lg">
        <Text ta="center" fw={600}>
          {title}
        </Text>
      </Flex>
      <div className={s['root__agenda-content']}>
        {useAgendaDocuments && organizationId && props.event ? (
          <div className={s.root__documents}>
            <ul className={s['root__documents-list']}>
              {props.event.documents.map((doc) => (
                <li key={doc.id} className={s['root__documents-item']}>
                  <Link
                    to={ROUTES.organization.documents.document.documentPreview.create(organizationId, doc.id)}
                    className={s['root__document-link']}
                  >
                    <IconFileText size={16} className={s['root__documents-icon']} />
                    <Text className={s.root__text}>{doc.name}</Text>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          showLatestDocuments &&
          organizationId &&
          props.latestDocuments && (
            <DocumentLinksList documents={props.latestDocuments} organizationId={organizationId} />
          )
        )}
      </div>
    </div>
  );
});

Slide.displayName = 'Slide';

export default React.memo(Slide);
